import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryAlarmsComponent } from './history-alarms/history-alarms.component';
import {ActiveAlarmsComponent} from './active-alarms/active-alarms.component';
import {AlarmsComponentsModule} from './components/alarms.components.module';
import { JournalComponent } from './journal/journal.component';
import { JournalSummaryComponent } from './journal/journal-summary/journal-summary.component';
import {SearchModule} from '../components/search/search.module';
import {LayoutModule} from '../components/layout/layout.module';
import {ActionBarModule} from '../components/action-bar/action-bar.module';
import {MaterialModule} from '../material.module';
import {ArmTableModule} from '../components/arm-table/arm-table.module';
import {InfoTreeModule} from '../components/info-tree/info-tree.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import { SnmpDestinationComponent } from './snmp-destination/snmp-destination.component';
import { SnmpDestinationDialogComponent } from './snmp-destination/snmp-destination-dialog/snmp-destination-dialog.component';
import {ClientFilterModule} from '../components/client-filter/client-filter.module';
import {DialogModule} from '../components/dialog/dialog.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AlarmsAdvancedComponent } from './alarms-advanced/alarms-advanced.component';
import {ArmFormModule} from '../components/arm-form/arm-form.module';
import {NzMentionModule} from 'ng-zorro-antd/mention';
import {NzInputModule} from 'ng-zorro-antd/input';
import {ArmFormTitleModule} from '../components/arm-form/arm-form-title/arm-form-title.module';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [ActiveAlarmsComponent, HistoryAlarmsComponent, JournalComponent, JournalSummaryComponent,
    SnmpDestinationComponent, SnmpDestinationDialogComponent, AlarmsAdvancedComponent],
    imports: [
        CommonModule,
        AlarmsComponentsModule,
        AlarmsComponentsModule,
        SearchModule,
        LayoutModule,
        ActionBarModule,
        MaterialModule,
        ArmTableModule,
        InfoTreeModule,
        FlexLayoutModule,
        ClientFilterModule,
        DialogModule,
        FormsModule,
        ArmFormModule,
        NzMentionModule,
        NzInputModule,
        ArmFormTitleModule,
        ReactiveFormsModule,
        InfraModule
    ]
})
export class AlarmsModule { }
